import { render, staticRenderFns } from "./ComparisonTable.vue?vue&type=template&id=5c4f7228&scoped=true"
import script from "./ComparisonTable.vue?vue&type=script&lang=js"
export * from "./ComparisonTable.vue?vue&type=script&lang=js"
import style0 from "./ComparisonTable.vue?vue&type=style&index=0&id=5c4f7228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4f7228",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardText,VChip,VCol,VContainer,VDataTable,VRow,VSelect,VTextField})
